// extracted by mini-css-extract-plugin
export default {"list":"SpeakersList_list__dNw8g"};